import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    header: {
      ...theme.fonts.h5,
      color: theme.colors.textDefault,
      fontFamily: "Red Hat Display",
    },
    label: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      fontFamily: "Red Hat Text",
    },
    dashboardRequirementSection: {
      marginTop: "24px",
      textAlign: "left",
    },
    activationRequirementSection: {
      marginTop: "16px",
      textAlign: "left",
    },
    requirements: {
      margin: 0,
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      paddingLeft: "12px",
      "& li": {
        fontFamily:
          '"Red Hat Text", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif',
      },
    },
    dashboardRequirements: {
      marginTop: "16px",
    },
    activationRequirements: {
      marginTop: "8px",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
